import React from 'react'
import { Section1 } from '../Sections'

function About(props) {
  return (
    <Section1>
      <h1 className='noSelect'>About</h1>
      <p>Too many good ideas and not enough time to make them happen?
      Put them here to share with the world.</p>
    </Section1>
  )
}

export default About
